module.exports = __webpack_public_path__ + "media/Images/icon-payroll-purple-cee4d3d7f4c6433949a9f18094f486af.svg";